<template>
  <v-container fluid>
    <p-loader></p-loader>
    <p-snackbar></p-snackbar>
    <p-change-password ref="changePassword"></p-change-password>
    <v-toolbar app dark color="primary">
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items id="top-menu">
        <v-menu transition="scale-transition" origin="left">
          <v-btn flat slot="activator">
            Ano Base: {{ this.$auth.user().anobase.id_texto || "Não definido" }}
            <v-icon dark>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(item, i) in this.$auth.user().anosbases"
              :key="i"
              @click="changeYear(item.id)"
            >
              <v-list-tile-title v-text="item.id_texto"></v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu
          v-if="this.$auth.user().acesso_interno == 'dev'"
          transition="scale-transition"
          origin="left"
        >
          <v-btn flat slot="activator">
            {{ this.$auth.user().empresa.id_texto }}
            <v-icon dark>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(item, i) in this.$auth.user().empresas"
              :key="i"
              @click="changeCompany(item.id)"
            >
              <v-list-tile-title v-text="item.id_texto"></v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <span></span>
        <v-btn to="/pessoa" flat :disabled="!hasAccess('pessoa', 'read')">Pessoa</v-btn>
        <v-btn @click="para('/contribuinte')" flat :disabled="!hasAccess('contribuinte', 'read')">
          Contribuinte
        </v-btn>
        <v-btn @click="para('/condominio')" :disabled="!hasAccess('condominio', 'read')" flat>
          Condominio
        </v-btn>
        <v-btn to="/anobase" :disabled="!hasAccess('anobase', 'read')" flat>Ano base</v-btn>
        <v-btn
          to="/usuario"
          :disabled="!hasAccess('usuario', 'read')"
          v-if="
            this.$auth.user().acesso_interno == 'dev' || this.$auth.user().acesso_interno == 'admin'
          "
          flat
        >
          Usuario
        </v-btn>
        <v-btn
          to="/acesso"
          :disabled="!hasAccess('acesso', 'read')"
          v-if="
            this.$auth.user().acesso_interno == 'dev' || this.$auth.user().acesso_interno == 'admin'
          "
          flat
        >
          Acesso
        </v-btn>
        <v-btn to="/suporte" flat :disabled="!hasAccess('suporte', 'read')">Suporte</v-btn>
        <v-menu origin="center center" transition="scale-transition">
          <v-btn flat slot="activator">
            {{ this.$auth.user().name }}
            <v-icon dark>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="changePassword()">
              <v-list-tile-title>Alterar Senha</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="logout()">
              <v-list-tile-title>Sair</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <!-- <atualizacao v-if="this.$auth.user().acesso_interno == 'dev'"></atualizacao> -->
        <v-menu
          v-if="this.$auth.user().acesso_interno == 'dev'"
          transition="scale-transition"
          origin="left"
        >
          <v-btn flat slot="activator">
            <v-icon dark>manage_accounts</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(item, i) in this.$auth.user().users"
              :key="i"
              @click="changeUser(item.id)"
            >
              <v-list-tile-title v-text="item.name"></v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <router-view />
      </v-card-text>
    </v-card>
    <v-footer app>
      <v-flex xs12 py-3 text-xs-center>
        <span>
          &copy; {{ new Date().getFullYear() }} -
          <strong>{{ title }}</strong>
        </span>
      </v-flex>
    </v-footer>
  </v-container>
</template>

// Quando o id esta como display none então não mostra o campo usado no v-money
<style>
#display-none {
  display: none;
}

#top-menu .v-btn--active:before {
  background: none !important;
}

.v-datatable td {
  padding: 2px 7px !important;
  height: 28px !important;
}

.v-datatable td .v-input--checkbox {
  width: 0 !important;
  margin: auto !important;
  justify-content: center;
}

.v-datatable td .v-input--checkbox .v-input__control {
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-datatable td button,
.v-datatable td .v-input__slot,
.v-datatable td .v-input--selection-controls__input {
  margin: 0 !important;
}

.v-datatable td .v-input--checkbox .v-messages,
.v-ripple__container {
  display: none;
}

.v-money:disabled {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.5);
}

.v-money:enabled {
  font-weight: 500;
}
</style>

<script>
import PLoader from "./../shared/PLoader";
import PSnackbar from "./../shared/PSnackbar";
import PChangePassword from "./../shared/PChangePassword";
import Atualizacao from "../crud/Atualizacao.vue";
import acl from "./../../mixin/acl";

export default {
  mixins: [acl],
  data() {
    return {
      drawer: false,
      years: [],
      items: [
        {
          icon: "bubble_chart",
          title: "Pessoas",
          route: "pessoa",
        },
        {
          icon: "bubble_chart",
          title: "Condominio",
          route: "condominio",
        },
        {
          icon: "bubble_chart",
          title: "Ano Base",
          route: "anobase",
        },
        {
          icon: "bubble_chart",
          title: "Usuários",
          route: "usuario",
        },
      ],
      title: "ContTech",
    };
  },
  name: "App",
  components: { PLoader, PSnackbar, PChangePassword, Atualizacao },
  methods: {
    para(route) {
      if (this.$router.currentRoute.path !== route) {
        this.$router.push(route);
        location.reload();
      }
    },
    changePassword: function () {
      this.$refs.changePassword.dialogChangePassword = true;
    },
    changeYear: function (anobase_id) {
      const { id } = this.$auth.user();

      this.$http.put(`auth/users/${id}`, { anobase_id }).then(
        (res) => {
          location.reload();
        },
        (err) =>
          function () {
            console.log(err);
          }
      );
    },
    changeCompany: function (empresa_id) {
      const { id } = this.$auth.user();

      this.$http.put(`auth/users/${id}`, { empresa_id }).then(
        (res) => {
          location.reload();
        },
        (err) =>
          function () {
            console.log(err);
          }
      );
    },
    changeUser: function (user_id) {
      const { id } = this.$auth.user();

      this.$http.put(`auth/users/${id}`, { user_id }).then(
        (res) => {
          localStorage.setItem("default_auth_token", res.body);
          location.reload();
        },
        (err) =>
          function () {
            console.log(err);
          }
      );
    },
    logout: function () {
      this.$auth.logout({
        makeRequest: true,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/In.vue